module.exports = __webpack_public_path__ + "static/img/icone-builder.c90d5eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icone-builder.png
// module id = ngAT
// module chunks = 0